<button class="light-blue-text back-btn" mat-icon-button (click)="takaisin()" type="button" aria-label="Takaisin">
  <i class="icon ion-md-arrow-back"></i>
</button>

@if (laskuObservable | async; as lasku) {
  <div class="maksut-katsele-page">
    <div class="left-container">
      <div style="margin-top: 2em">
        <h2>{{ lasku.seller || '–' }}</h2>

        @if (kirjanpitajaOnDevaajaObservable | async) {
          <div class="light-gray-text" style="margin-bottom: 1em">
            Ostolasku: <a [href]="ostolaskuEncodedUriObservable | async" target="_BLANK">{{ ostolaskuUriObservable | async }}</a>
          </div>
        }

        <div class="tiedot-row">
          <div class="left-col">Tyyppi</div>
          <div class="right-col">{{ tyyppiNimi(lasku.type) }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Maksun tila</div>
          <div class="right-col">{{ paymentStatusNimi(lasku.paymentStatus) }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Toimittajan avain</div>
          <div class="right-col mono">{{ lasku.toimittajaAvain || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Sellerin id</div>
          <div class="right-col mono">{{ lasku.sellerId || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Laskun numero</div>
          <div class="right-col mono">{{ lasku.laskunumero || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Viitenumero</div>
          <div class="right-col mono">{{ lasku.viitenumero || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Laskun pvm</div>
          <div class="right-col">{{ lasku.invoiceDate | lnumberpvm | async }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Eräpäivä</div>
          <div class="right-col">{{ lasku.dueDate | lnumberpvm | async }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Maksupäivä</div>
          <div class="right-col">{{ lasku.paymentDate | lnumberpvm | async }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Toimituspäivä</div>
          <div class="right-col">{{ lasku.deliveryDate | lnumberpvm | async }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Summa</div>
          <div class="right-col">{{ lasku.sum ?? lasku.summa | number: '1.2-2' : 'fi-FI' }} {{ lasku.currency || 'EUR' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Maksutapa</div>
          <div class="right-col mono">{{ lasku.maksutapa ?? '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">ALV-vähennysoikeus</div>
          <div class="right-col">{{ lasku.alvVahennysoikeus ?? '–' }}</div>
        </div>

        <div class="tiedot-row" style="height: initial">
          <div class="left-col">Selite</div>
          <div class="right-col">{{ lasku.selite || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Lähde</div>
          <div class="right-col mono">{{ lasku.lahde || '–' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Tallennettu</div>
          <div class="right-col">{{ lasku.vastaanotettuPalvelimelle?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Päivitetty</div>
          <div class="right-col">{{ lasku.paivitetty?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
        </div>

        <div class="tiedot-row">
          <div class="left-col">Poistettu</div>
          <div class="right-col">{{ lasku.poistettu ? 'Kyllä' : 'Ei' }}</div>
        </div>

        @if (lasku.einvoiceApprovalStatus) {
          <div class="tiedot-row">
            <div class="left-col">Hyväksyntä</div>
            <div class="right-col">{{ lasku.einvoiceApprovalStatus }}</div>
          </div>
        }
        @if (lasku.einvoiceForwardingStatus) {
          <div class="tiedot-row">
            <div class="left-col">Edelleenlähetys</div>
            <div class="right-col">{{ lasku.einvoiceForwardingStatus }}</div>
          </div>
        }

        <div class="tiedot-row">
          <div class="left-col">Avain</div>
          <div class="right-col mono">{{ lasku.avain }}</div>
        </div>
      </div>
    </div>

    <div class="tosite-sivut">
      @for (kuva of kuvatObservable | async; track kuva.avain) {
        <div class="kuva-container">
          <img [src]="kuva.url" crossorigin="use-credentials" loading="lazy" class="mat-elevation-z4" />
        </div>
      }
    </div>
  </div>
} @else {
  <div class="maksut-katsele-page">
    <div class="left-container">
      <div class="tyhja-tila">Ostolaskua ei löytynyt.</div>
    </div>
  </div>
}
